import { Icon, IconProps } from "@chakra-ui/react";

export function CircleArrowLeftIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 40 40" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0001 5.83332C12.176 5.83332 5.83341 12.176 5.83341 20C5.83341 27.824 12.176 34.1667 20.0001 34.1667C27.8241 34.1667 34.1667 27.824 34.1667 20C34.1667 12.176 27.8241 5.83332 20.0001 5.83332ZM4.16675 20C4.16675 11.2555 11.2556 4.16666 20.0001 4.16666C28.7446 4.16666 35.8334 11.2555 35.8334 20C35.8334 28.7445 28.7446 35.8333 20.0001 35.8333C11.2556 35.8333 4.16675 28.7445 4.16675 20Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9226 14.4107C19.248 14.7362 19.248 15.2638 18.9226 15.5892L15.3452 19.1667L26.6667 19.1667C27.1269 19.1667 27.5 19.5398 27.5 20C27.5 20.4602 27.1269 20.8333 26.6667 20.8333L15.3452 20.8333L18.9226 24.4107C19.248 24.7362 19.248 25.2638 18.9226 25.5892C18.5972 25.9147 18.0695 25.9147 17.7441 25.5892L12.7441 20.5892C12.4186 20.2638 12.4186 19.7362 12.7441 19.4107L17.7441 14.4107C18.0695 14.0853 18.5972 14.0853 18.9226 14.4107Z"
        fill="currentColor"
      />
    </Icon>
  );
}
